import React from 'react';
import { connect } from 'react-redux';
import { WebsiteState } from '@gift/website-state/store';
import { selectConfig3d } from './_redux-variants';
import { BasicPreview2d } from './preview/BasicPreview2d';
import { BasicPreview3d } from './preview/BasicPreview3d';
import { useToggle } from '@gift/ui/hooks/useToggle';
import { PreviewUiElement } from '@gift/ui/components/preview-ui-element/PreviewUiElement';
import { LightSwitch } from '@gift/ui/components/light-switch/LightSwitch';
import { Icon } from '@gift/ui/components/icons/Icon';
import styles from './BasicPreviewUi.module.scss';

const _BasicPreviewUi = ({ has3d }: Props) => {

    const [show3d, toggle3d] = useToggle();

    return (
        <div className={styles.default}>
            {has3d && (
                <PreviewUiElement className={styles.toggle}>
                    <LightSwitch checked={show3d} onChange={toggle3d}>
                        <Icon type='three-dimensional' size='medium' />
                    </LightSwitch>
                </PreviewUiElement>
            )}

            {show3d
                ? <BasicPreview3d />
                : <BasicPreview2d />}
        </div>
    );
};

type Props = {
    has3d: boolean
};

const mapStateToProps = (state: WebsiteState) => ({
    has3d: !!selectConfig3d(state)
});

export const BasicPreviewUi = connect(
    mapStateToProps
)(_BasicPreviewUi);